import { Slug } from '@bridebook/toolbox/src/types';
import { IBreadcrumbItem } from '@bridebook/web/app-shared/lib/types';
import { getBreadcrumbsWithHome } from '@bridebook/web/app-shared/lib/utils';
import { getI18n } from '@bridebook/web/lib/i18n/getI18n';
import { UrlHelper } from '@bridebook/web/lib/url-helper';

export const getBreadcrumbsSupplierCategory = (name?: string, slug?: Slug): IBreadcrumbItem[] => {
  const i18n = getI18n();

  const weddingSuppliersItem = {
    name: i18n.t('common:topBarLinks.suppliers'),
    path: UrlHelper.search,
    id: 'suppliers',
  } as IBreadcrumbItem;

  const showWeddingSuppliersItem = !['venue', 'venues'].includes(slug?.toString() || '');

  const breadcrumbItems: IBreadcrumbItem[] = showWeddingSuppliersItem ? [weddingSuppliersItem] : [];

  return getBreadcrumbsWithHome(name, breadcrumbItems);
};
